export default __webpack_public_path__ + "static/media/map-start.6994589e.svg";